<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="试卷名称">
              <el-input v-model="searchParams.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="考试类型">
              <select-option-dictionary
                v-model="searchParams.extype"
                @change="search()"
                dkey="exp-type">
              </select-option-dictionary>
            </el-form-item>
          </el-col>
          <div class="search-btn">
            <el-button type="primary" icon="el-icon-search" @click="search"
              >搜索</el-button
            >
            <el-button @click="clearSearchVal">清空</el-button>
          </div>
        </el-row>
      </el-form>
    </div>

    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData"
        stripe
        border
        height="auto"
        @selection-change="selectionChange"
        v-loading="listLoading"
      >
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
        ></el-table-column>
        <!-- <el-table-column prop="cid" label="考试班级id"></el-table-column> -->
        <el-table-column
          prop="name"
          width="300"
          label="试卷名称"
        >
        <template slot-scope="scope">
             <span :title="scope.row.name">{{ scope.row.dbColumn_expid }}</span>
          </template>
      </el-table-column>
      <el-table-column  prop="type"  width="160" label="类型">
					<template slot-scope="scope">
					  <el-tag type="danger"  v-if="scope.row.type==1"  size="mini">线下-{{ scope.row.extype == 1?'小测':(scope.row.extype == 2?'周测':'阶段测') }} </el-tag>
						<el-tag type="warning" v-else-if="scope.row.type==2"  size="mini">模拟面试-{{ scope.row.extype == 1?'小测':(scope.row.extype == 2?'周测':'阶段测') }}</el-tag>
						<el-tag type="danger"  effect="dark" v-else-if="scope.row.type==4"  size="mini">面试轮训-{{ scope.row.extype == 1?'小测':(scope.row.extype == 2?'周测':'阶段测') }}</el-tag>
						<el-tag type="success" v-else size="mini">线上-{{ scope.row.extype == 1?'小测':(scope.row.extype == 2?'周测':'阶段测') }}</el-tag>
            <el-tag type="primary" v-if="scope.row.toInterviewer" size="mini">提问:{{scope.row.toInterviewer}}</el-tag>
            
          </template>
        </el-table-column>
        <el-table-column prop="score" width="160" label="个人得分/试卷总分">
          <template slot-scope="scope">
            {{
              scope.row.isjudged
                ? scope.row.anscore
                : (scope.row.answer? "待批改": "缺考")
            }}/{{ (scope.row.type==2 ||scope.row.type==4) ?100:   scope.row.exscores }}
          </template>
        </el-table-column>
        <el-table-column prop="exduration" width="135" label="考试时长(分钟)">
        </el-table-column>
        <el-table-column prop="startTime" label="开始/截止时间">
          <template slot-scope="scope">
            <el-tag size="mini" type="success">
              {{ scope.row.startTime }}</el-tag
            >
            <el-tag size="mini" type="danger"> {{ scope.row.endTime }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button v-if="scope.row.isjudged"
                size="mini"
                @click="toDetail(scope.$index, scope.row)"
                >  查看成绩</el-button>
                <el-button v-else
                size="mini"
                @click="showInfo()"
                >  等待批改</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :total="listData.total"
          :page-size="page.size"
          :current-page="page.current"
          :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"
        ></el-pagination>
      </div>
    </div>
    <hisTest ref="hisTest"></hisTest>
    <interviewdetail ref="interviewdetail"></interviewdetail>
  </div>
</template>
<script>
import hisTest from "./hisTest.vue";
import interviewdetail from "./correct4.vue";
import imageUpload from "@/components/biz/imageUpload/imageUpload.vue";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import api from "@/api/exams/exams/exams.js";

export default {
  name: "exams",

  components: {
    hisTest,
    interviewdetail,
    imageUpload,
    selectOptionDictionary,
  },
  data() {
    return {
      startTest: false,
      name: "",
      extype: "",
      searchParams: { type: 2 },
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      page: new this.$constant.pageObj(),
      stuid: "",
    };
  },
  watch: {
    "searchParams.name": function() {
      this.search();
    },
  },

  methods: {
    //去回显考试
    toDetail(index, row) {
      let times = {
        nowTime: row.nowtime,
        endTime: row.endTime,
      }
     // console.log("Row1",row);
      if(row.type==2||row.type==4){
        this.$refs.interviewdetail.open(row.id, this.stuid, "查看问答测试结果" );
      }else{
        this.$refs.hisTest.open(row.id, this.stuid, "查看考试 - " + (row.name?row.name:row.dbColumn_expid ),times);
      }
      
    },showInfo(){
      this.$utils.msg.warning( "批改后/考试到期后解锁"   );
    },

    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams, this.page,{isHK:1});
      api.list(params, (response) => {
        this.listData = response.data.records;
     
        this.listLoading = false;
      });
    },

    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    //搜索
    search() {
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = { type: 2 };
      this.list();
    },
  },
  mounted() {
    this.list();

    let me = this.$caches.user.get();
    this.stuid = me.id;
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
.el-tag {
  margin: 0 5px;
}
</style>
